import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DealsService } from './deals.service';


export const DealsResolver: ResolveFn<any> = (route) => {
  const dealsService = inject(DealsService);
  const platformId = inject(PLATFORM_ID);

  const deal = route.paramMap.get('deal');

  if (isPlatformServer(platformId)) {
    return dealsService.getDealsData(deal ?? '');
  } else {
    dealsService.getDealsData(deal ?? '');
    return null;
  }
};
